import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private apiUrl = environment.apiUrl + '/Upload';

  constructor(private http: HttpClient) {}

  file(formData: FormData, folder: string): Observable<string[]> {
    return this.http.post<string[]>(`${this.apiUrl}?folder=${folder}`, formData);
  }

  files(formData: FormData, folder: string): Observable<string[]> {
    return this.http.post<string[]>(`${this.apiUrl}/multiple?folder=${folder}`, formData);
  }
}
